import type { InputNumberDesignTokens } from '@primeuix/themes/types/inputnumber'

export default {
  root: {
    transitionDuration: '{transition.duration}',
  },
  button: {
    width: '2.5rem',
    borderRadius: '{form.field.border.radius}',
    verticalPadding: '{form.field.padding.y}',
  },
  colorScheme: {
    dark: {
      button: {
        color: '{surface.300}',
        background: '{surface.800}',
        hoverColor: '{surface.200}',
        activeColor: '{surface.100}',
        borderColor: '{form.field.border.color}',
        hoverBackground: '{surface.700}',
        activeBackground: '{surface.500}',
        hoverBorderColor: '{form.field.border.color}',
        activeBorderColor: '{form.field.border.color}',
      },
    },
    light: {
      button: {
        color: '{surface.600}',
        background: '{surface.100}',
        hoverColor: '{surface.700}',
        activeColor: '{surface.800}',
        borderColor: '{form.field.border.color}',
        hoverBackground: '{surface.200}',
        activeBackground: '{surface.300}',
        hoverBorderColor: '{form.field.border.color}',
        activeBorderColor: '{form.field.border.color}',
      },
    },
  },
} satisfies InputNumberDesignTokens
